// Copyright (c) 2020 Deere & Company

import RgaSearchResult from '../../rga/rga-search-results/state-connector';

export default {
    component: RgaSearchResult,
    name: 'Mass Update Search Results',
    path: '/rga/results/mass-update'
};




// WEBPACK FOOTER //
// ./src/routes/rga/rga-mass-update-results.js